import {createFileRoute} from '@tanstack/react-router';

import {ExpenseCategoriesPage} from '@/modules/admin-settings/pages/ExpenseCategoriesPage';

export const Route = createFileRoute('/_authenticated/admin/settings/expense-categories/')({
  component: ExpenseCategoriesPage,
});
